import { Configuration, DefaultHeaders, NgxOAuthClient } from 'ngx-oauth-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';


@DefaultHeaders({
  'Content-Type': 'application/json',
  'Accept':       'application/json'
})
@Configuration({
  host:  environment.autServer,
  token: 'login'
})

export class Api extends NgxOAuthClient {

  errorInterceptor(request, error) {
    if (error && error.error && error.error.message) {
      return Observable.throw(error.error.message);
    } else {
      return Observable.throw(error.status);
    }
  }

  requestInterceptor(request) {
    const token = this.fetchToken('access_token');
    if (token) {
      return request.setHeaders({ Authorization: 'Bearer ' + token });
    }
    return request;
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/api.ts